var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    fill: "none",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_406_665)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DE4C36",
    fillRule: "evenodd",
    d: "M494.662 233.836L277.204 16.394c-12.514-12.525-32.827-12.525-45.358 0l-45.155 45.155 57.282 57.281c13.312-4.497 28.575-1.481 39.187 9.132 10.662 10.678 13.657 26.072 9.05 39.428l55.205 55.205c13.356-4.602 28.766-1.623 39.433 9.06 14.908 14.903 14.908 39.057 0 53.97-14.913 14.913-39.067 14.913-53.986 0-11.214-11.225-13.984-27.695-8.306-41.51l-51.484-51.483-.005 135.481a38.58 38.58 0 0110.093 7.219c14.908 14.902 14.908 39.057 0 53.981-14.913 14.908-39.078 14.908-53.969 0-14.908-14.924-14.908-39.079 0-53.981a38.227 38.227 0 0112.492-8.328V190.26a37.688 37.688 0 01-12.492-8.328c-11.296-11.28-14.012-27.854-8.225-41.724l-56.461-56.472L15.399 232.83c-12.53 12.536-12.53 32.849 0 45.374l217.458 217.447c12.52 12.525 32.827 12.525 45.363 0l216.442-216.436c12.525-12.531 12.525-32.854 0-45.379",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_406_665"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H500V498.054H0z",
    transform: "translate(6 7)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGit);
export default __webpack_public_path__ + "static/media/git.72a5fef40f3804d6422911ff5b295e3c.svg";
export { ForwardRef as ReactComponent };